import HowToBlock from './HowToBlock'

export default HowToBlock
